import React from 'react';

import { STATUS_ACTIVE } from 'scenes/Users/PartnerUsers/constants';
import {
  useBlockPartnerUser,
  useUnblockPartnerUser,
} from 'scenes/Users/PartnerUsers/data';

import Actions from './Actions';

const PartnerActions = ({ data, onEdit, onDuplicate }) => {
  const [blockPartnerUser] = useBlockPartnerUser();
  const [unblockPartnerUser] = useUnblockPartnerUser();

  const handleDuplicate = () => {
    onDuplicate(data);
  };

  const handleEdit = () => {
    onEdit(data);
  };

  const handleBlock = ({ id, name }) => {
    blockPartnerUser({ id, name });
  };

  const handleUnBlock = ({ id, name }) => {
    unblockPartnerUser({ id, name });
  };

  return (
    <Actions
      onEdit={() => handleEdit(data)}
      onDuplicate={() => handleDuplicate(data)}
      onBlock={() => handleBlock(data)}
      onUnBlock={() => handleUnBlock(data)}
      isActive={data.status.id === STATUS_ACTIVE}
    />
  );
};

export default PartnerActions;
